module.exports = __webpack_public_path__ + "static/media/V2_06.5287de31.png";